import React from 'react';
import PropTypes from 'prop-types';
import styles from "../../../SearchWidget.module.scss";

const MoreAirportsBtn = ({children, selected, visible, ...props}) => {

    if (!visible) {
        return null;
    }

    const moreAirportsBtnClasses = [styles.moreAirportsBtn];
    if (selected) moreAirportsBtnClasses.push(styles.moreAirportsBtnSelected);

    return (
        <div {...props}
             className={moreAirportsBtnClasses.join(' ')}>
            {children}
        </div>
    );
};

MoreAirportsBtn.propTypes = {
    children: PropTypes.any,
    visible: PropTypes.bool,
    selected: PropTypes.bool,
};

MoreAirportsBtn.defaultProps = {
    children: null,
    visible: true,
    selected: false,
};

export default MoreAirportsBtn;
